import {ProgressBarState} from '../../constants/timeProgressBar';
import {getState} from '../common/time_progress_bar/helpers/getState';
import {FC, useEffect, useMemo} from 'react';
import useTimer, {getDatesDifferenceInSeconds} from '../../hooks/useTimer';
import {
  calculateAlertRange
} from '../common/time_progress_bar/helpers/calculateAlertRange';
import {AlertSettingsProps} from '../settings/alert_alarm/types';

type ProcessExpiredTimeProps = {
  startedAt: string,
  completedAt: Nullable<string>,
  targetTime: number,
  alertSettings: Nullable<AlertSettingsProps>,
  timeFormat: (time: number) => void,
  setProcessState?: (state: ProgressBarState) => void
}

const ProcessExpiredTime: FC<ProcessExpiredTimeProps> = ({
  startedAt,
  completedAt,
  targetTime,
  alertSettings,
  timeFormat,
  setProcessState
}) => {
  const alertRange = useMemo(() => {
    if (!alertSettings) return 0;

    const {relative, relativeRange, absoluteRange} = alertSettings;
    return calculateAlertRange(
        relative,
        relativeRange,
        absoluteRange,
        targetTime
    );
  }, [JSON.stringify(alertSettings)]);

  const initialDatesDiff = useMemo(() => {
    return getDatesDifferenceInSeconds(startedAt, completedAt);
  }, [startedAt, completedAt]);

  const {timeDiffInSeconds} = useTimer({
    initialDiff: initialDatesDiff,
    initialActive: !!startedAt && !completedAt
  });

  const expiredTime = useMemo(() => {
    return timeFormat(timeDiffInSeconds - targetTime);
  }, [timeDiffInSeconds, targetTime]);

  const {color, state} = getState({
    currentTime: timeDiffInSeconds,
    alertRange,
    targetTime,
    isCurrentlyRunning: false
  });

  useEffect(() => {
    if (setProcessState) setProcessState(state);
  }, [setProcessState, state]);

  return (
    <span className={`running-processes-element_expired-time ${color}`}>
      {state === ProgressBarState.NORMAL ?
          `-${expiredTime}` : `+${expiredTime}`}
    </span>
  );
};

export default ProcessExpiredTime;
